import {t} from "@lingui/core/macro"

// Les balises de la page d'une vente, calculées une seule fois pour les cinq
// thèmes — ils ne diffèrent que par l'habillage, jamais par ce qu'ils annoncent.
//
// `context.enchere` est posé au rendu serveur (services/EnchereMetaService.js).
// Absent — page de liste, vente introuvable, API lente — on retombe sur le
// titre générique : la page reste correcte, elle est seulement moins parlante.
//
// Aucune DATE dans les textes de repli : le serveur et le navigateur ne la
// formatent pas pareil, et l'écart ferait échouer l'hydratation de React.
export function metaEnchere(context) {
    const vente = (context && context.enchere) || null
    if (!vente) return {title: t`Enchères`, description: null, image: null}

    const nom = vente.label || ""
    const titre = vente.metaTitle || (nom ? t`Enchères — ${nom}` : t`Enchères`)

    let description = vente.metaDescription
    if (!description && nom) {
        description = vente.state === "CLOSE"
            ? t`Les enchères de ${nom} sont terminées. Découvrez les résultats.`
            : t`Les enchères de ${nom} sont ouvertes. Enchérissez en ligne, depuis votre téléphone.`
    }

    return {title: titre, description: description || null, image: vente.metaImage || null}
}
